//FocusController.js

import $ from 'jquery';
import eventBus from 'EventBus';
import { Model }            from 'backbone';
import listService from 'ListService';
import mobileListService from '../service/mobile/MobileListService';
import constants   from 'Constants';
import util        from 'util/Util';
import BaseController from 'BaseController';
import EditableControlView      from 'EditableControlView';
import viewManagerService from 'ViewManagerService';
import mobileGroupDomHandler from '../views/mobile/containers/MobileGroupDomHandler'
import thumbPageListUtil from 'util/ThumbPageListUtil';


//==================================================================
//
// A singleton that handles "focus" changes on controls.
//
// For example, clicking a control instance causes that control to
// receive the PF focus / interest. A listener in this controller
// must replace the current property views with the four property
// views for the focus control.
//
// We use event delegation to mitigate leaks of handlers when
// we delete controls. Delegation also eliminates the need for
// dozens of identical event listeners when there are dozens of
// controls in a form.
//
// November 27, 2015.
//
//==================================================================
class FocusController extends BaseController {

    constructor() {
        super();

        this._noMark = {
            'control_date_calendar':        1,
            'control_vertical_separator':   1,
            'control_horizontal_separator': 1,
            'control_multiple_text_input':  1,
            'control_text_input':           1
        }

        // So tests can assert  our instance hierarchy is a singleton
        FocusController.instanceCount = FocusController.instanceCount === undefined ? 1 : FocusController.instanceCount + 1 ;
    }

    //------------ For tests asserting extender is a singleton: ---

    static get instanceCount() { return FocusController._instanceCount; }

    static set instanceCount(arg) { FocusController._instanceCount = arg; }

    get instanceCount() { return FocusController.instanceCount; }

    //----------- End test support --------------------------------

    get noMark() { return this._noMark; }

    // Differentiate events: prevent collisions with handler on/off for given event in other modules.
    get namespace() { return '.nameSpaceFocusController';}

    //================================================================
    // Enable/disable 
    //================================================================

    removeCursorsOfSelectionBox() {
        $('#aPage div.size-handle-top').css('cursor', '');
        $('#aPage div.size-handle-bottom').css('cursor', '');
        $('#aPage div.size-handle-left').css('cursor', '');
        $('#aPage div.size-handle-right').css('cursor', '');
    }

    changeCursorsOfSelectionBox(eId, colCursor='default', rowCursor='default') {
        util.jqId(eId).find('div.size-handle-top').css('cursor', rowCursor);
        util.jqId(eId).find('div.size-handle-bottom').css('cursor', rowCursor);
        util.jqId(eId).find('div.size-handle-left').css('cursor', colCursor);
        util.jqId(eId).find('div.size-handle-right').css('cursor', colCursor);
    }

    //================================================================
    // Draw selection rectangle of a control after resetting all
    // marked controls.
    // Don't draw selection on stationary controls, however.
    //================================================================
    selectionRectangle( id, requestSelection = true, resetAll = true ) {

        if ( !constants.SELECTION_EXCLUSION[ id]  ) {
            let currentObject = null;
            if (listService.mainKind === constants.KIND_MOBILE) {
                currentObject = mobileListService.getMobileControl(id);
            }
            else {
                currentObject = listService.getObject(id);
            }

            if (requestSelection) {

                    util.jqId(id).closest('div .pf-selectable.group').addClass('pfSelected');
                    util.jqId(id + '.pf-selectable' ).addClass('pfSelected');
                    if(!listService.isGroup(id) && currentObject && currentObject.model.get('factoryKey') !==  "control_section"){
                        util.jqId(id + ' .pf-selectable' ).addClass('pfSelected');
                        util.jqId(id + ' .pf-control-core.pf-selectable' ).addClass('pfSelected');
                    }
                    // PF-2524: Enable resize handles
                    // PF-1155 Timer control is not resizable so dont execute this line.
                    if(currentObject && currentObject.model.get('factoryKey') !== 'control_timer') {
                        util.jqId(id).resizable('enable');
                        //currentObject.createResizeControl();
                    }

                    this.removeCursorsOfSelectionBox();
                    this.changeCursorsOfSelectionBox(id, 'col-resize', 'row-resize');

                    if(listService.isGroup(id)){
                        util.jqId(id).attr('draggable', 'true');
                    }


                // Focus the control: turns on the selection border
                window.setTimeout(e => $(constants.ID_SEL + id).trigger(constants.EV_FOCUS), 0);
            } else {
                //It could be cut instead of copy, in that case element doesn't exist in DOM we need to check
                if( util.jqId(id).length !== 0){
                    util.jqId(id + '.pf-selectable').removeClass('pfSelected');
                    util.jqId(id + ' .pf-selectable').removeClass('pfSelected');
                    //util.jqId(id + ' .pf-control-core').removeClass('pfSelected');

                    // PF-2524: Disable resize handles
                    // PF-1155 Timer control is not resizable so dont execute this line.
                    if(currentObject.model.get('factoryKey') !== 'control_timer') {
                       //util.jqId(id) && util.jqId(id).resizable('disable'); 
                    }
                    else{
                        $('.asset-control').removeClass('pfSelected');
                    }

                    this.removeCursorsOfSelectionBox();
                    this.changeCursorsOfSelectionBox(id);

                    if(listService.isGroup(id)){
                        util.jqId(id).attr('draggable', 'false');
                    }
                }
            }
        }
    }


    //================================================================
    // Mark control in negative color on initial drop / creation
    // Deprecated - PF-1111
    //================================================================
    markControl( id, wantMarked, resetAll = true ) {

        // PF-1111 - Brad says not to mark. Just select. We implement select elswhere

        /*
        const view =  listService.getObject ( id );

        const getBgColor = vw => {
            return (vw && vw.model && vw.model.attributes)
                ? vw.model.attributes.backgroundColor
                : constants.CLR_INVISIBLE;
        }

        // Reset all marks
        if (resetAll) {
            listService.objectList.map((view, domId) => {
                util.jqId( domId )
                    .css({'color': constants.CLR_BLACK, 'background-color': getBgColor(view)});
            });
        }

        // Only now, deal with argument mark
        // (No view if we're multi-selected)
        if ( view ) {
            const factoryKey = view.model.get('factoryKey');

            $(constants.ID_SEL + id).css(
                wantMarked && !this.noMark[factoryKey]
                    ? {'color': constants.CLR_WHITE, 'background-color': constants.CLR_BLACK}
                    : {'color': constants.CLR_BLACK, 'background-color': getBgColor(id)}
            );

            this.broadcastName(view);
        }
        */
    }


    //=====================================================================
    // Clear selection rectangles from all controls. Then delete the
    // record of those selections.
    //=====================================================================
    clearAllSelected() {

        $('.pf-selectable').removeClass('pfSelected');
        //If edit text inline is present clean it
        if(listService.$ed){
            listService.$ed.off('dblclick');
            listService.$ed.remove();
            listService.$ed = undefined;
        }
        // Clear record of all selected controls
        listService.clearSelected();
        if (listService.mainKind === constants.KIND_MOBILE) {
            mobileGroupDomHandler.disableHandlers()
        }
    }


    //=====================================================================
    // Toggle selection rectangle of current control. Then delete the
    // or record it in the list of selections, accordingly
    //=====================================================================
    toggleOneSelection( id ) {

        //only objects in the same container can be selected
        if(listService.selected.size > 0){
            const firstId = listService.selected.first().id;
            const otherIdGroup = listService.getGroupObject(firstId);
            const idGroup = listService.getGroupObject(id);

            if(otherIdGroup !== idGroup){
                this.clearAllSelected();
            }
        }

        const isSelected = listService.isSelected( id );
        const resetAll = false;

        // Flip the visual
        this.selectionRectangle( id, !isSelected, resetAll );

        // Flip the backing record of selection
        if (isSelected) {
            listService.deleteFromSelected( id );
        } else {
            listService.addToSelected( id );
        }

        // PF-1218 If just one item now selected, then we ensure we show its properties
        if (listService.selectedCount === 1){
            listService.currentId = listService.selected.first().id;
            this.switchPropsViews( );
        }

    }


    //=====================================================================
    // Maintain properties and selection outline of current focus control
    // Use JQuery event delegation on the parent of all controls, the page,
    // and the form.
    //
    // One listener to rule them all,
    // One listener to find them,
    // One listener to bring them all,
    //   and in the darkness bind them
    //
    // "I shan't call it the end, 'til we've cleared up the mess." - Sam
    //
    // DELEGATES through LAYOUT_ID
    //=====================================================================
    startControlFocusListeners( $canvas2Id ) {

        const excludeFromSelection = constants.SELECTION_EXCLUSION,
            $page = $(constants.PAGESEL_ID);

        // Namespaces differentiate handlers to fight "event disconnect" spaghetti
        const namespace = this.namespace;

        const $layout = $(constants.LAYOUT_ID),
            delegate = constants.INSTANCE_CORE_CLASS;

        // Each new instance that can lose focus has focus delegated delegated to this method.
        $layout
            .off( constants.EV_CLICK + namespace, delegate)
            .on( constants.EV_CLICK + namespace, delegate, ev => {
                // An active inline text editor is modal: don't mess with focus or property switching.

                if (ev.currentTarget.classList.contains('pfSelected')) {
                    return false;
                }

                if (listService.$ed) {
                    ev.stopImmediatePropagation();
                }

                // A class pf-control with a domID assumed to be the parent to the core element
                let id = ev.currentTarget.parentElement.id;
                let container =  ev.currentTarget.parentElement;
                if (!id) {
                    id =  ev.currentTarget.parentElement.parentElement.id;
                    container =  ev.currentTarget.parentElement;
                }

                let section = null;
                if (listService.mainKind === constants.KIND_MOBILE) {
                    listService.getSectionById(id);
                }

                if (!section) {
                    //If this event comes from a multiselectiongroup quit to keep elements selected
                    //on the multiselection
                    if( listService.isGroup(id) ){
                        if(listService.isFromMultSelectionGroup){
                            return;
                        }
                    }
                }


                // Toggle focus control if shift or meta key depressed
                // Note ev.ctrlKey not useful for Macs. A Mac hijacks it as contextmenu event.
                if ( ev.shiftKey || ev.metaKey || ev.ctrlKey ) {
                    this.toggleOneSelection( id );
                }
                else if ( excludeFromSelection[ id ] ) {
                    // We see that page or form is current id, but we won't list it as selected.
                    // Otherwise we'd reset multi-selection from a drawn rectangle.
                    listService.currentId = id;
                }
                else  {
                    // Otherwise, "normal" click processing when shift key up:

                    // Clear selected because: we know shift key is up AND: if
                    // less than two controls are focused, OR if click is on a non-selected control
                    const isSelected = listService.selected.get( id );
                    if ( listService.selectedCount < 2 || !isSelected )  {
                        this.clearAllSelected( );
                    }

                    // Select the target control (not page or form).
                    if (!excludeFromSelection[ id] && !section) {

                        let currentObject = null;
                        if (listService.mainKind === constants.KIND_MOBILE) {
                            currentObject = mobileListService.getMobileControl(id);
                        }
                        else {
                            currentObject = listService.getObject(id);
                        }

                        const domControl = $('#' + currentObject.id);
                        //PF-6257 Timer control is not resizable so the jquery function causes problems
                        if (domControl.resizable !== undefined && currentObject && currentObject.model.get('factoryKey') !== 'control_timer') {
                           domControl.resizable('enable');
                        }

                        // PF-1155 Drawing a selection rectangle for timer control.
                        if (currentObject && currentObject.model.get('factoryKey') === 'control_timer') {
                            $('.asset-control').removeClass('pfSelected');
                            util.jqId(id).addClass('pfSelected');
                        }

                        if (listService.mainKind === constants.KIND_MOBILE) {
                            $('div.mobile-column.pfSelected').removeClass('pfSelected');
                            if (listService.isGroup(id)) { // should be found in mobileObjMap
                                mobileGroupDomHandler.enableHandlers(container);
                            } else if (mobileGroupDomHandler.isGroupItemHandler(ev.currentTarget.firstElementChild)) {
                                mobileGroupDomHandler.enableHandlers(container.parentElement);
                                mobileGroupDomHandler.selectHandlers(ev.currentTarget.firstElementChild);
                            }
                        }

                        this.selectionRectangle(id, true);
                    }




                    listService.currentId = id;
                    listService.addToSelected( listService.currentId );

                    const obj = listService.getObject(id);

                    if(obj){
                        const oName = obj.model.get("name");
                        $('.rail-header-text').text(oName + constants.RIGHT_PANEL_PROPERTIES_TITLE);
                        $('.rail-header-text').prop('title', oName + constants.RIGHT_PANEL_PROPERTIES_TITLE);
                        eventBus.trigger(constants.EV_UPDATE_BREADCRUMB, 'OBJECT', id);
                    }

                }

                // Set arrow cursor. Otherwise we get text cursor during move over text.
                $page.css('cursor', 'default');
                $('#settings-tab a').on("click");
                let currentSize = listService.selectedCount;

                if (currentSize > 1) {
                    // Show like Properties
                    viewManagerService.renderLayoutPropertyTabs(new Model(), {multipleSelected: true});
                } else {
                    setTimeout( () => {
                        this.switchPropsViews();
                    }, 0);
                }

                $('#settings-tab a').on("click");

                util.validateMenuItems(currentSize);

                // PF-1401 Removing selected columns if any on selecting a control.
                const columnSelectedSelector= $(`#${id}`) ;
                columnSelectedSelector.find('td').removeClass('column-selection');
                columnSelectedSelector.find('th').removeClass('column-selection');

                let selectedItem=listService.selected.toArray();

                if(selectedItem.length === 1 && selectedItem[0]) {
                    util.updateHelpDocumentationLink(selectedItem[0].model.get('factoryKey'));
                }
                // PF-3087: Highlight the selected control on thumbnail section
                const currentPageId = listService.currentPageId;
                const $well = util.jqId(`well${currentPageId}`);
                $well.collapse('show');
                const pageSwitch = $('a[data-target="#well'+currentPageId +'"] i');
                pageSwitch.removeClass('pf-carot-left').addClass('pf-carot-down');

                $('.page-selected').removeClass('page-selected');
                $(`[data-page='${currentPageId}']`).parent().closest('div')
                    .addClass('page-selected').addClass('expanded-page').removeClass('collapsed-page');

                $('.controlSelected').removeClass('controlSelected');
                let itemToSelect = selectedItem[0];
                if (itemToSelect && itemToSelect._groupId) {
                    let parent = listService.getObject(itemToSelect._groupId);
                    thumbPageListUtil.expandControlParent(parent);
                }
                $well.find(`li[data-id="${listService.currentId}"]`).addClass('controlSelected');

                return false;

            });

        // Forward mouse-moves or mouse-up occurring atop a control to the page below it.
        //
        // DON'T do it if we're not dragging a multi-selection rectangle. That would swallow the mouse-down
        // of a drag=start on the control
        //
        // Forwarding enables the page to a maintain multi-selection rectangle mouse interaction while
        // the mouse passes over this control. If it's not carrying out a multi-selection, the
        // page will have no listener; the event bubbles out of existence.

        $layout
            .off(constants.EV_MOUSEMOVE + namespace, delegate)
            .off(constants.EV_MOUSEUP + namespace, delegate)
            .on(constants.EV_MOUSEMOVE + namespace, delegate, ev => {

                if (listService.isHandleInsideGroup) {
                    return;
                }

                let returnValue = false;
                // Set arrow cursor, else we may have a text cursor during mouse movement over text.
                if (listService.isDrawingMultiSelection) {
                    $page.css('cursor', 'default');
                    $page.triggerHandler(ev);
                } else if (listService.isResizing) { //PF-2456 - Resize event is not releasing always
                    $page.triggerHandler(ev);
                } else {
                    returnValue = true;
                }

                return returnValue;
            })
            .on(constants.EV_MOUSEUP + namespace, delegate, ev => {
                $page.triggerHandler(ev);
                //console.log('mouseup');
                return true;
            });


    }



    //=================================================================================================
    // Broadcast current focus control's name
    //=================================================================================================
    broadcastName(view ) {
        const name = view.model.get( 'name');
        eventBus.trigger( constants.CEV_NAME_CHANGE, name);
    }

    //=================================================================================================
    // Each control view should hold its own property view references.
    // Light up the new focus view, and its property view dependents, but deafen the property subviews
    // for all the other controls. Otherwise all the controls can pile atop one-another. Read on ...
    //=================================================================================================
    switchPropsViews( ) {

        // To prevent model-to-model leakage of properties across instances of a property view,
        // turn off all subview Backbone property listeners. The issue was that n controls have n
        // event listeners for each property view class. All navigation view instances share one $el.
        // A model change would update all views for that associated $el, view visible or not. Each such
        // view would propagate a change to its own DIFFERENT model. Thus changes leaked across
        // models. Hurts my head.
        //
        // (If turning ALL listeners off for each focus change seems draconian, we could maintain a
        // lagging "current ID", and just turn off its property listeners when a new current Id is focused.)

        /*
        listService.objectList.map( view => {
            if ( view.subviews ) {
                view.subviews.map( propertyView => propertyView.undelegateEvents() );
            }
        });
*/
        // Close any open inline text editor (e.g. user tabbed out, clicked outside, or keyed enter, without change)
        if (listService.$ed) {
            listService.$ed.trigger('change');
            setTimeout( () => {
                listService.$ed.off('dblclick');
                listService.$ed.remove();
                listService.$ed = undefined;
            }, 0);
        }


        // Now turn ON only the property listeners (BackBone) for just the current control.
        // I.E. Turn on event listeners for this control's sub-views only.

        let  view = null;

        if (listService.mainKind === constants.KIND_MOBILE) {
            view = mobileListService.getMobileControl( listService.currentId ) ;
        }else{
            view = listService.getObject( listService.currentId ) ;
        }

        if (view) {
            //view.configureSubviews();

            view.delegateEvents();

            /*
            view.subviews.map( pview => {
                pview.render();
                pview.delegateEvents();
            });
            */
            // PF-1401 Refreshing the properties header as its not being cleaned after clicking other control and then clicking the canvas.
            if (view.model.get('displayControlName')!=='Form' && view.model.get('factoryKey') === 'layout_frame'){
                view.model.set('displayControlName','Form',{silent:true})
            }


            this.broadcastName(view);

            viewManagerService.renderLayoutPropertyTabs(view.model);
        }
    }

    switchTab(tabName){

        // Close any open inline text editor (e.g. user tabbed out, clicked outside, or keyed enter, without change)
        if (listService.$ed) {
            listService.$ed.trigger('change');
            setTimeout( () => {
                listService.$ed.off('dblclick');
                listService.$ed.remove();
                listService.$ed = undefined;
            }, 0);
        }

        // Now turn ON only the property listeners (BackBone) for just the current control.
        // I.E. Turn on event listeners for this control's sub-views only.
        const view = listService.getObject( listService.currentId ) ;

        if (view) {
            //view.configureSubviews();

            view.delegateEvents();

            /*
            view.subviews.map( pview => {
                pview.render();
                pview.delegateEvents();
            });
            */
            // PF-1401 Refreshing the properties header as its not being cleaned after clicking other control and then clicking the canvas.
            if(view.model.get('displayControlName')!=='Form' && view.model.get('factoryKey') === 'layout_frame'){
                view.model.set('displayControlName','Form',{silent:true})
            }

            this.broadcastName(view);

            viewManagerService.renderTab(tabName,view.model);
        }
    }

}

// Expose singleton only
const focusController = new FocusController();
export default focusController;
